import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { usePayReferralMutation } from "@modules/referrals/services/mutations";
import { PayReferralFormValues, payReferralSchema } from "@modules/referrals/validations";

export function usePayReferralModal(
  modalRef: RefObject<ModalRef>,
  onComplete?: () => void,
) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<PayReferralFormValues>({
    resolver: zodResolver(payReferralSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = usePayReferralMutation({
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("referral_admin.success.pay"),
      });

      onComplete?.();
      modalRef.current?.close();
    },
  });

  return {
    methods,
    mutateAsync,
    isPending,
  };
}
